<script>
import Header from "@/components/Template/Header.vue";
import Footer from "@/components/Template/Footer.vue";

export default {
    name: "App",
    components: {
        Header,
        Footer
    }
};
</script>

<template>
    <Header/>
    <div id="body" class="flex-center m-block m-pad">
        <router-view/>
    </div>
    <Footer/>
</template>